export const envsArray = [
  {
    url: 'https://api.mypsychic.com',
    logo: '/mp.jpg',
    name: 'MyPsychic'
  },
  {
    url: 'https://api.psychics247.com',
    logo: '/p247.png',
    name: 'Psychics24/7'
  },
  {
    url: 'https://api.tarotfox.com',
    logo: '/tf.png',
    name: 'TarotFox'
  },
  {
    url: 'https://api.taroteagle.com',
    logo: '/te.png',
    name: 'TarotEagle'
  },
  {
    url: 'https://api.tarotmistico.com',
    logo: '/tm.png',
    name: 'TarotMistico'
  },
  {
    url: 'https://api.expertosenromance.com',
    logo: '/er.png',
    name: 'ExpertosEnRomance'
  },
  {
    url: 'https://api.spiritspace.com',
    logo: '/ss.png',
    name: 'SpiritSpace'
  },
  {
    url: 'https://api.healingspace.com',
    logo: '/hs.png',
    name: 'HealingSpace'
  }
];



// WEBPACK FOOTER //
// ./src/config/config.prod.js